module.exports = __webpack_public_path__ + "img/ccdszhinengtop.805377fa.png";